import React, { useState, useEffect } from 'react';
import { Modal, Button, Typography, Form, Input, Row, Col } from "antd";
import { platformApi } from '../../../../api';
import moment from 'moment';

const { Text } = Typography;

const ViewNumberPlating = ({ open, close, rowData, form }) => {
  const { getFieldDecorator, setFieldsValue } = form;

  useEffect(() => {
    if (rowData) {
      setFieldsValue({
        plateOrderStatus: rowData.plateOrderStatus,
        customerName: rowData.customerName,
        modelName: rowData.modelName,
        applicationNo: rowData.applicationNo,
        chassisNo: rowData.chassisNo,
        registerNo: rowData.registerNo,
        dealershipName: rowData.dealershipName,
        applicationType: rowData.applicationType,
        goodsCareerMGV: rowData.goodsCareerMGV,
        makerName: rowData.makerName,
        engineNo: rowData.engineNo,
        createdAt: rowData.createdAt,
        updatedAt: rowData.updatedAt
      });
    }
  }, [rowData, setFieldsValue]);

  return (
    <Modal
      width="70%"
      title="Number Plate Details"
      visible={open}
      onCancel={close}
      footer={[
        <Button key="close" onClick={close}>
          Close
        </Button>
      ]}
    >
      <Form layout="vertical">
        {/* First Row */}
        <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Date">
            <Input 
              disabled 
              value={moment(rowData?.createdAt).format('DD/MM/YYYY') || 'N/A'}
            />
          </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Customer Name">
              {getFieldDecorator('customerName')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Model Name">
              {getFieldDecorator('modelName')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
        </Row>

        {/* Second Row */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Application No">
              {getFieldDecorator('applicationNo')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Application Type">
              {getFieldDecorator('applicationType')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Chassis No">
              {getFieldDecorator('chassisNo')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
        </Row>

        {/* Third Row */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Register No">
              {getFieldDecorator('registerNo')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Order Status">
              {getFieldDecorator('plateOrderStatus')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Engine No">
              {getFieldDecorator('engineNo')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
        </Row>

        {/* Fourth Row */}
        <Row gutter={16}>
        <Col span={8}>
            <Form.Item label="Maker Name">
              {getFieldDecorator('makerName')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Dealership Name">
              {getFieldDecorator('dealershipName')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Goods Career MGV">
              {getFieldDecorator('goodsCareerMGV')(
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          
        </Row>
     
      </Form>
    </Modal>
  );
};

export default Form.create()(ViewNumberPlating);